import { render } from "./App.vue?vue&type=template&id=22d2fc03"
const script = {}

import "./App.vue?vue&type=style&index=0&id=22d2fc03&lang=css"

import exportComponent from "/home/user/Desktop/enon-projects/fimit-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__